import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from './Config';
import { isTokenValid } from './Utils/jwtTokenValidation';

// Define a new Axios instance for file upload with a different base URL
const FileUploadAPI = axios.create({
  baseURL: config.FILE_SERVICE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// Request interceptor to include the JWT token in the headers of every request
FileUploadAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken'); 
    if (token) {
      if (isTokenValid(token)) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        toast.error("Invalid or expired token. Please log in again.");
        localStorage.clear(); 
        window.location.href = "/"; 
      }
    }
    return config;
  },
  (error) => {
    toast.error("Something went wrong");
    return Promise.reject(error);
  }
);

export default FileUploadAPI;
